import Tooltip from '@components/Tooltip';
import { CircleIconWrapper } from '@ContractBuilder/contract-builder-header/components/CircleIconWrapper';
import { DrawerLayoutComponent } from '@ContractBuilder/modules/drawer-layout';
import { useEntityStore } from '@ContractBuilder/store';
import { useDrawerStore } from '@ContractBuilder/store/drawer.store';
import { ValidationStatusBadge } from '@features/contract-validation/check-validation-panel/components/ValidationStatusBadge';
import { ShieldCheckIcon } from '@heroicons/react/outline';
import { shallow } from 'zustand/shallow';

export const TemplateValidationController = () => {
  const { closeDrawer, isDrawerOpen, openDrawer, state } = useDrawerStore(
    ({ closeDrawer, isOpen, openDrawer, state }) => ({
      closeDrawer,
      isDrawerOpen: isOpen,
      openDrawer,
      state,
    }),
    shallow,
  );
  const submission = useEntityStore(({ submission }) => submission);

  const isOpen = isDrawerOpen && state?.type === DrawerLayoutComponent.TemplateValidation;

  const handleToggle = () => {
    if (isOpen) {
      return closeDrawer();
    }
    return openDrawer({ type: DrawerLayoutComponent.TemplateValidation, props: {} });
  };

  const totalRequired = submission?.contract_number_of_required_data_points ?? 0;
  const missingCount = submission?.contract_missing_data?.length ?? 0;
  const badgeType = missingCount === 0 ? 'valid' : 'warning';

  return (
    <ValidationStatusBadge type={badgeType} showBadge={totalRequired > 0}>
      <Tooltip content="Check validation">
        <CircleIconWrapper
          icon={ShieldCheckIcon}
          isActive={isOpen}
          onClick={handleToggle}
          data-testid="template-validation-icon"
        />
      </Tooltip>
    </ValidationStatusBadge>
  );
};
